import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import firebase from "firebase";


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Dashboard
  },
  {
    path: '/new-video/:room',
    name: 'new-video',
    props: true,
    component: function () {
      return import('@/video-module/Video.vue')
    }  
  },
  {
    path: '/about',
    name: 'about',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: function () {
      return import(/* webpackChunkName: "settings" */ '../views/Settings.vue')
    }
  },
  {
    path: '/setup/:ref',
    name: 'setup',
    props: true,
    component: function () {
      return import(/* webpackChunkName: "setup" */ '../views/RetrieveAccount.vue')
    }
  },
  {
    path: '/retrieve',
    name: 'retrieve',
    component: function () {
      return import(/* webpackChunkName: "setup" */ '../views/RetrieveAccount.vue')
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Contact.vue')
    }
  },
  {
    path: '/video-test/:ref',
    props: true,
    name: 'video-test',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../components/communication/video/VideoTest.vue')
    }
  },
  {
    path: '/appointment-setup/:ref',
    props: true,
    name: 'appointment-setup',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../components/tools/ParticipantStepper.vue')
    }
  },
  {
    path: '/passwordreset/',
    name: 'passwordreset',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/PasswordReset.vue')
    }
  },
  {
    path: '/view/:type',
    name: 'view',
    props: true, 
    component: function () {
      return import(/* webpackChunkName: "view" */ '../components/List.vue')
    }
  },
  {
    path: '/view/:type/:id',
    name: 'viewObject',
    props: true,
    // meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "projects/view" */ '../components/Single.vue')
  },
  {
    path: '/edit/:type/:id',
    name: 'edit',
    props: true, 
    component: () => import(/* webpackChunkName: "edit" */ '../components/Edit.vue')
  },
  {
    path: '/login',
    name: 'login',
    props: true,
    component: function () {
      return import(/* webpackChunkName: "login" */ '../components/Login.vue')
    }
  },
  {
    path: '/profile',
    name: 'profile',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue')
  },
  {
    path: '/video',
    name: 'video',
    props: true,
    component: function () {
      return import(/* webpackChunkName: "video" */ '../components/communication/video/VideoAppointment.vue')
    }
  },
  {
    path: '/survey/:id',
    name: 'survey/:id',
    props: true, 
    // meta: { requiresAuth: true },
    component: function () {
      return import(/* webpackChunkName: "survey" */ '../views/Survey.vue')
    }
  },
  {
    path: '/scheduling/:id',
    name: 'scheduling/:id',
    props: true, 
    // meta: { requiresAuth: true },
    component: function () {
      return import( '../components/tools/Scheduler.vue')
    }
  },
  {
    path: '/new-request',
    name: 'new-request',
    // meta: { requiresAuth: true },
    component: function () {
      return import( '../components/forms/RequestForm.vue')
    }
  },
  {
    path: '/system-tasks',
    name: 'system-tasks',
    // meta: { requiresAuth: true },
    component: function () {
      return import( '../views/SystemTasks.vue')
    }
  },
  {
      path: '/client',
      name: 'client',
      // meta: { requiresAuth: true },
      component: function () {
        return import( '../views/Client.vue')
      }
  },  
  {
    path: '/:namedPath',
    name: 'namedPath',
    // meta: { requiresAuth: true },
    component: function () {
      return import( '../views/Post.vue')
    },
  },
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) next('login');
  else next();
})

export default router
